<template lang="html">
  <section>
    <div class="botones-pagina">
      <button class="boton boton--rojo-tema" @click="logout">
        <i class="fal fa-sign-out"/>
        <span>Cerrar sesión</span>
      </button>
    </div>
    <div class="grid grid--padding">
      <div class="col-6">
        <h4 class="h4">Cambiar contraseña</h4>
        <form novalidate @submit.stop.prevent="cambiarPassword(claveNueva)">
          <form-group>
            <input type="password" class="form__input" v-model="claveNueva">
            <label for="" class="form__label">Nueva contraseña</label>
          </form-group>
          <button type="submit" class="boton boton--azul">
            <i class="fa far fa-key"/>
            <span>Cambiar</span>
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import D from "debug";
import api from "./perfilApi.js";

const debug = D("ciris:Perfil.vue");

export default {
  data,
  methods: {
    logout,
    cambiarPassword,
  },
};

function data() {
  return {
    claveNueva: "",
  };
}

function logout() {
  this.$auth.logout();
  this.$router.push("/login");
}

function cambiarPassword(password) {
  debug("cambiarPassword");
  return this.$validator.validateAll()
    .then((valido) => {
      if (valido) {
        const cliente = {
          _id: this.$auth.credenciales.sub,
          password,
        };
        return api.guardar(cliente)
          .then(() => {
            this.$toastr("success", "Se ha modificado su contraseña", "Contraseña Cambiada");
            this.claveNueva = "";
            return null;
          })
          .catch((err) => {
            debug(err);
            this.$toastr("error", "No se pudo cambiar la contraseña", "Error");
          });
      }
      return null;
    });
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/perfil/Perfil.vue